module.exports = __webpack_public_path__ + "static/hakimov-b8239bccc064a9e02b3444eb242c2304.jpg";